<template>
  <li class="dropdownItem dropdownItem__mobilePay">
    <a
      class="dropdownItem__toggle user-profile dropdown-toggle"
      href="javascript:;"
      data-toggle="dropdown"
      aria-expanded="true"
    >
      儲值管理
      <span class="dropdownItem__icon fa fa-angle-down"></span>
    </a>
    <ul class="dropdown-menu dropdown-usermenu pull-right">
      <li class="dropdownItem__listItem">
        <router-link
          class="dropdownItem__href"
          :to="'/serviceMain/stored-item'"
          v-if="permissionStore"
        >
          儲值設定
        </router-link>
      </li>
      <li class="dropdownItem__listItem">
        <router-link
          class="dropdownItem__href"
          :to="'/serviceMain/stored-record'"
          v-if="permissionStore"
        >
          儲值/扣款紀錄
        </router-link>
      </li>
    </ul>
  </li>
</template>
<script>
export default {
  props: ['permissionStore'],
  data() {
    return {}
  },
}
</script>
<style lang="scss" scoped>
@import 'src/scss/_dropdownItem.scss';
</style>



// WEBPACK FOOTER //
// src/components/dropDown/DropdownStored.vue